module.exports = __webpack_public_path__ + "static/img/lyw.d09d433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/lyw.png
// module id = w9qx
// module chunks = 1